export enum Density {
  Standard = 'Standard',
  Sparse = 'Sparse',
  Dense = 'Dense',
}
